import React, { useContext } from 'react'
import merge from 'lodash/merge'
import { ParagraphProps } from './Paragraph.types'
import { ThemeContext } from '../../Themer/Themer'
import Title from '../Title/Title'

const Paragraph: React.FC<ParagraphProps> = ({
    isBold = false,
    size = 'md',
    title,
    titleProps = {},
    style = {},
    colGap,
    colCount,
    children,
}) => {
    const themeContext = useContext(ThemeContext)

    const _style = merge(style, {
        columnCount: colCount || 1,
        columnGap: colGap || themeContext.theme.spacing * 2 + 'px',
    })
    return (
        <div data-testid='Paragraph' className={`r-paragraph-container r-size-${size} ${isBold ? 'r-text-bold' : ''}`}>
            {title ? <Title {...titleProps}>{title}</Title> : ''}
            <p style={_style}>{children}</p>
        </div>
    )
}

export default Paragraph
